import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { useCurrentUserIdAsync } from 'src/app/shared/hooks/session';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActionsAsync } from 'src/app/shared/hooks/share';
import { isLoaded } from 'src/app/shared/utils/async';

import { useGetTrackingData } from './useGetTrackingData';
import { useGetUrl } from './useGetUrl';

type UseMobileNativeShareReturn = ShareAction | null;
export function useMobileNativeShare(): UseMobileNativeShareReturn {
	const {
		data: {
			petition: { id: petitionId, slug, user: petitionUserId },
		},
	} = usePetitionDetailsPageData();

	const currentUserState = useCurrentUserIdAsync();
	const currentUserId = isLoaded(currentUserState) ? currentUserState.value : undefined;
	const getUrl = useGetUrl(slug, currentUserId);
	const getContent = (_channel: ShareChannel) => '';
	const getTrackingData = useGetTrackingData(petitionUserId, currentUserId, petitionId);
	const trackingEventName = 'share_petition';
	const channels = ['mobileNativeShare'] as const;
	const options = { trackingEventName, getUrl, getTrackingData, getContent };
	const actionsState = useAvailableShareActionsAsync(channels, options);
	const shareAction = isLoaded(actionsState) ? actionsState.actions[0] : null;

	return shareAction;
}
